import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { Subscription } from 'rxjs';

// Import facade and types
import { CalculatePremoFacade } from './calculate-premo.facade';
import type { CalculatePremoUiState } from './calculate-premo.facade';

@Component({
    standalone: true,
    selector: 'app-calculate-premo',
    imports: [...COMMON_IMPORTS],
    templateUrl: './calculate-premo.component.html',
})
export class CalculatePremoComponent implements OnInit, OnDestroy {
    public orgId: string;
    public patientId: string;
    public uiState: CalculatePremoUiState | null = null;

    private uiStateSub?: Subscription;
    private urlLoaded: boolean = false;

    public constructor(
        private readonly route: ActivatedRoute,
        private readonly sanitizer: DomSanitizer,
        public readonly facade: CalculatePremoFacade,
    ) {
        this.orgId = this.route.snapshot.paramMap.get('orgId')!;
        this.patientId = this.route.snapshot.paramMap.get('patientId')!;
    }

    public getSafeDashboardUrl(): SafeResourceUrl | null {
        if (this.uiState?.dashboardUrl && !this.urlLoaded) {
            this.urlLoaded = true;
            return this.sanitizer.bypassSecurityTrustResourceUrl(this.uiState.dashboardUrl);
        }
        return null;
    }

    public async ngOnInit() {
        this.uiStateSub = this.facade.uiState$.subscribe((state: CalculatePremoUiState) => {
            this.uiState = state;
        });

        await this.facade.initializeCalculatePremo(this.orgId, this.patientId);
    }

    public ngOnDestroy(): void {
        this.uiStateSub?.unsubscribe();
        this.facade.destroy();
    }
}
